export default "__VITE_ASSET__DxzffKlf__"